import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
export function loadImage(_x) {
  return _loadImage.apply(this, arguments);
}
function _loadImage() {
  _loadImage = _asyncToGenerator(function* (url) {
    // @ts-ignore
    if (window.createImageBitmap) {
      const response = yield fetch(url);
      const imageBitmap = yield createImageBitmap(yield response.blob());
      return imageBitmap;
    } else {
      const image = new window.Image();
      return new Promise(res => {
        image.onload = () => res(image);
        image.src = url;
        image.crossOrigin = 'Anonymous';
      });
    }
  });
  return _loadImage.apply(this, arguments);
}